import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/index.css'
import store from './store'
import router from './router'
import { getToken } from '@/utils/auth'
import { login } from '@/api/auth'
import Cookies from 'js-cookie'



Vue.config.productionTip = false
Vue.use(ElementUI);


router.beforeEach((to, from, next) => {
  let token = getToken()
  if(to.meta.requiresAuth && !token) {
    router.push({path: '/login'})
  }else{
    next()
  }
  
 
})
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
